<script>
  import { onMount } from 'svelte'
  import Button from './Button.svelte'
  import { snackBarStore, tenantStore, userStore } from '../state/store'
  import { t } from '../i18n/i18n'
  import { stripe } from '../helpers/utils'
  import { request } from '../helpers/api'
  const jwtDecode = require('jwt-decode')

  let elements = stripe.elements()
  let card // HTML div to mount card
  let cardElement
  let complete = false
  let pending = false
  let cardInfo = ''

  const style = {
    base: {
      fontFamily: '"IBM Plex Sans Condensed", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
    },
    invalid: {
      color: "#cc2929",
      iconColor: "#cc2929"
    }
  }
  onMount(async () => {
    createCardForm()
  })

  $: if ($tenantStore._id) {
      getCardLast4()
    }
  

  const createCardForm = async () => {
    cardElement = elements.create('card', {style})
    cardElement.mount(card)
    cardElement.on('change', (e) => complete = e.complete)
  }

  const getCardLast4 = async () => {
    try {
      cardInfo = await request({
        url: `/api/payments?tenant=${$tenantStore._id}`,
      }) 
    } catch (error) {
      console.error(error)
    }
  }

  const updatePayment = async ({cardElement}) => {
    pending = true
    try {
      const response = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
      })
      const { paymentMethod } = response
      updateSubscription({
        paymentMethodId: paymentMethod.id,
      })
    } catch (error) {
      snackBarStore.set({ message: $t.something_wrong, type: 'error' })
    }
  }
  
  
  const updateSubscription = async ({ paymentMethodId }) => {
    try {
     const response = await fetch('/api/payments', {
        method: 'PUT',
        body: JSON.stringify({
          customerId: $tenantStore._id,
          paymentMethodId,
        })
      })

      if (!response.ok) throw new Error($t.something_wrong_payment)

      const result = await response.json()
      if (result) {
        pending = false
        snackBarStore.set({ message: $t.payment_updated, type: 'success' })
        getCardLast4()
      }
      const { token } = await request({url: '/api/refresh'})
      sessionStorage.setItem('token', token)
      const { user } = jwtDecode(token)
      userStore.set(user)
    } catch (error) {
      pending = false
      snackBarStore.set({ message: $t.something_wrong, type: 'error' })
    }
}

</script>

<style>

  section {
    height: 100%;
    background: var(--white);
    padding: 2rem 0;
    display: flex;
    flex-direction: column;
  }

  article {
    display: grid;
  }

  .elements {
    margin: 2rem 0;
    border: 2px solid #ccc;
    border-radius: var(--radius);
    padding: 1rem;
    width: min(45rem, 100%);
    justify-self: end;
  }

  .button {
    margin-top: auto;
    text-align: right;
    padding: 0;
  }

  span {
    text-align: center;
  }

</style>

<section>
  {#if $userStore.status === 'no_active_subscriptions'}
    <span class="g-error">{$t.no_active_plan}</span>
  {:else if $userStore.status !== 'active' && $userStore.status !== 'trialing'}
    <span class="g-error">{$t.subscription_inactive_admin}</span>
  {/if}
  <article>
    <h3>{$t['Update Credit Card Information']}</h3>
    {#if cardInfo}
      <p>{`Current card ends with: ${cardInfo.last4} exp.(${cardInfo.exp_month}/${cardInfo.exp_year})` }</p>
    {/if} 
    <div class="elements" bind:this={card}></div>
  </article>
  <div class="button">
    <Button color='success' on:click={() => updatePayment({cardElement})} disabled={!complete || pending}>
      {$t['Update Credit Card Information']}
    </Button>
  </div>
    
</section>

